
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import type { Expense } from "@/types/expense";
import { format, isValid } from 'date-fns';
import { Timestamp } from "firebase/firestore";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}


export function exportToCsv(filename: string, rows: Expense[]) {
  if (!rows || rows.length === 0) {
    return;
  }

  const formatDate = (date: any) => {
    if (!date) return '';
    if (date instanceof Timestamp) {
        return format(date.toDate(), 'yyyy-MM-dd');
    }
    if (typeof date === 'string') {
        const d = new Date(date);
        if (isValid(d)) {
            return format(d, 'yyyy-MM-dd');
        }
    }
    if (date.seconds && typeof date.seconds === 'number') {
        return format(new Date(date.seconds * 1000), 'yyyy-MM-dd');
    }
    return '';
  }

  const headers = ['Date', 'Description', 'Employer', 'Retailer', 'Amount'];
  const csvContent = [
    headers.join(','),
    ...rows.map(row => {
      const description = row.description ? `"${row.description.replace(/"/g, '""')}"` : '""';
      const retailer = row.retailer ? `"${row.retailer.replace(/"/g, '""')}"` : '""';
      const employer = row.employer ? `"${row.employer.replace(/"/g, '""')}"` : '""';
      return [
        formatDate(row.date),
        description,
        employer,
        retailer,
        row.amount
      ].join(',');
    })
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
